export default "__VITE_ASSET__ff66dcd0__"